import { createFileRoute } from "@tanstack/react-router";

import { LieuxPage } from "@/features/referentiels/LieuxPage";

export const Route = createFileRoute("/_connecte/lieux")({
  component: LieuxPage,
});
